import { createIsomorphicFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import Cookies from "js-cookie";

export const getAccessTokenFn = createIsomorphicFn()
  .server(() => {
    return getCookie("accessToken");
  })
  .client(() => {
    return Cookies.get("accessToken");
  });
